import Cookies from "js-cookie";
import req from "../js/req";
import { ref } from "vue";
class User {
  _message_unread_count = ref(0);
  _notice_unread_count = ref(0);
  _nav_title_callback_ = null;
  // constructor(unread_cout){
  //    this._message_unread_count = unread_cout
  // }

  async updateUnreadMessageCount() {
    const p = {
      ...User.getUTP(),
    };
    let data = await req.get(req.path.get_unread_message_count, p);
    User.getInstance()._message_unread_count.value = data;
  }
  async updateUnreadNoticeCount() {
    const p = {
      ...User.getUTP(),
    };
    let data = await req.get(req.path.get_unread_notice_count, p);
    User.getInstance()._notice_unread_count.value = data;
  }
  setNavTitleCallBack(callback) {
    this._nav_title_callback_ = callback;
  }

  static isLogin() {
    const uid = Cookies.get("uid");
    const token = Cookies.get("token");
    if (typeof uid == "string") {
      return uid != "undefined" && token != "undefined";
    } else {
      return uid != undefined && token != undefined;
    }
  }
  static loginOut() {
    Cookies.remove("uid");
    Cookies.remove("token");
    Cookies.remove("info");
    Cookies.remove('is_loaded')
  }

  static getUid() {
    return Cookies.get("uid");
  }
  static getToken() {
    return Cookies.get("token");
  }
  static setUT(uid, token) {
    Cookies.set("uid", uid);
    Cookies.set("token", token);
  }
  static setUserInfo(userInfo) {
    const userInfoString = JSON.stringify(userInfo);
    Cookies.set("info", userInfoString);
  }
  static getUserInfo() {
    const sString = Cookies.get("info");
    const json = JSON.parse(sString);
    return json;
  }
  static setIsLoaded() {
    Cookies.set("is_loaded", 1);
  }
  static getIsLoaded() {
    const sString = Cookies.get("is_loaded");
    return sString;
  }
  static getUTP() {
    // return {
    //   'uid': Cookies.get('uid'),
    //   'token': Cookies.get('token')
    // }
    return {
      uid: Cookies.get("uid"),
      token: decodeURIComponent(Cookies.get("token")),
    };
  }

  // static setPraise(classify_id){
  //    const p_js =   Cookies.get('praise')
  //    let josn_obj = {}
  //    if(p_js){
  //       josn_obj = JSON.parse(p_js);
  //    }
  //    josn_obj[classify_id] = true
  //    const json_string =  JSON.stringify(josn_obj)
  //    Cookies.set('praise',json_string)
  // }

  // static getPraise(classify_id){
  //    const p_js =   Cookies.get('praise')
  //    if(p_js){
  //       const json_obj = JSON.parse(p_js);
  //       const value_ = json_obj[classify_id]
  //       return  value_ == true
  //    }else{
  //       return false
  //    }
  // }
}

User.getInstance = (function () {
  let instance = null;
  return function () {
    if (!instance) {
      instance = new User();
    }
    return instance;
  };
})();

export default User;
